import React from "react";
import Footer from "./Footer";

export const PageShell = ({ children, testid }) => (
  <div className="min-h-screen flex flex-col bg-white" data-testid={testid}>
    <header className="border-b border-gray-200 bg-white/90 backdrop-blur sticky top-0 z-40">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center space-x-3" data-testid="pageshell-home-link">
          <div className="w-8 h-8 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-sm">C</span>
          </div>
          <span className="text-xl font-bold text-gray-900">Culinera</span>
        </a>
        <nav className="flex items-center gap-5 text-sm font-medium text-gray-600">
          <a href="/?view=wizard" className="hover:text-teal-600 hidden sm:inline">Plan a Trip</a>
          <a href="/?view=restaurants" className="hover:text-teal-600 hidden sm:inline">Directory</a>
          <a href="/blog" className="hover:text-teal-600">Journal</a>
        </nav>
      </div>
    </header>
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

export default PageShell;
